export class Locations {

    public id: string;
    public formatted_address: string;
    public lat: number;
    public lng: number;
    public quantity: number;

}
